import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../utils/axios';

const SettingsContext = createContext(null);

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_URL;

export const buildAssetUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_ORIGIN}${path}`;
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await API.get('/settings', { params: { _t: Date.now() } });
      setSettings(data || {});
    } catch (e) {
      setSettings({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Apply favicon dynamically
  useEffect(() => {
    if (!settings?.favicon) return;
    const url = buildAssetUrl(settings.favicon);
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = url;
  }, [settings?.favicon]);

  return (
    <SettingsContext.Provider value={{ settings: settings || {}, loading, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const ctx = useContext(SettingsContext);
  if (!ctx) throw new Error('useSettings must be used within SettingsProvider');
  return ctx;
};
